<script>
import { FilterMatchMode } from '@primevue/core/api';

export default {
  emits: ['templateSelected'],
  data () {
    return {
      dialog: false,
      loading: true,
      templates: [],
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
    }
  },
  async mounted() {
    await this.getTemplates();
  },
  methods: {
    async getTemplates() {
      this.loading = true;
      // Fetch templates
      const response = await fetch('/api/templates-text', {
        credentials: "include"
      })
      const status_code = response.status;
      if (status_code !== 200) {
        // Show toast
        this.$toast.add({ severity: 'error', summary: 'Fout', detail: 'Kon sjablonen niet laden.', life: 3000 });
      }
      // Parse the response and save templates
      this.templates = await response.json();
      this.loading = false;
    },
    selectTemplate(data) {
      this.dialog = false;
      this.$emit('templateSelected', data);
    },
    toggleTemplateBody(template) {
      if (template.showBody) {
        template.showBody = false;
      }
      else {
        template.showBody = true;
      }
    },
  },
}
</script>


<template>

  <div style="height: 6px" class="loader">
    <ProgressBar mode="indeterminate" style="height: 6px" v-if="loading"></ProgressBar>
  </div>

  <DataTable
    :value="templates"
    size="small"
    sortField="name"
    :sortOrder="1"
    scrollable
    scrollHeight="flex"
    dataKey="id"
    filterDisplay="row"
    v-model:filters="filters"
    :globalFilterFields="['name', 'user']"
  >
    <template #empty>
      <template v-if="loading">
        Sjablonen worden geladen..
      </template>
      <template v-else>
        Geen sjablonen gevonden.
      </template>
    </template>

    <template #header>
<!--      <div class="flex justify-end">-->
        <InputText v-model="filters['global'].value" placeholder="Zoeken" />
<!--      </div>-->
    </template>

    <Column :exportable="false" style="width: 190px;">
      <template #body="slotProps">
        <Button size="small" label="Sjabloon invoegen" rounded class="mr-2" @click="selectTemplate(slotProps.data)">
          <template #icon><i class="far fa-plus"></i></template>
        </Button>
      </template>
    </Column>
    <Column field="name" header="Naam" sortable>
      <template #body="{ data }">
        {{ data.name }}

        <Button :label="data.showBody === true ? 'Verberg sjabloon' : 'Toon sjabloon'" size="small" text @click="toggleTemplateBody(data)"></Button>

        <template v-if="data.showBody === true">
          <Divider />
          <div v-html="data.template_html"></div>
        </template>

      </template>
    </Column>
    <Column field="user" header="Aangemaakt door" sortable>
      <template #body="{ data }">
        <span>{{ data.user }}</span>
      </template>
    </Column>
  </DataTable>

</template>

<style lang="scss">

</style>
